<template>
  <UModal
    v-model:open="isOpen"
    overlay
    :close="false"
    :dismissible="false"
    :ui="{ content: 'sm:max-w-2xl sm:w-full' }"
  >
    <template #body>
      <ConsentModalContent
        v-model:consent="consentOptions"
        @accept-all="onClickAcceptAll"
        @decline-all="onClickDeclineAll"
        @save="saveSettings"
      />
    </template>
  </UModal>
</template>

<script setup lang="ts">
import { useGtm } from '@gtm-support/vue-gtm'

const isOpen = ref(false)

onMounted(() => {
  const consentCookie = useCookie('cc')

  // NOTE: check if the user has an old consent cookie without the advertising key
  const consentCookieKeyCount = consentCookie.value
    ? Object.keys(consentCookie.value).length
    : 0

  isOpen.value = !consentCookie.value || consentCookieKeyCount < 3
})

const consentOptions = ref({
  necessary: true,
  analytics: false,
  advertising: false,
})

function onClickAcceptAll() {
  consentOptions.value.analytics = true
  consentOptions.value.advertising = true
  saveSettings()
}

function onClickDeclineAll() {
  consentOptions.value.analytics = false
  consentOptions.value.advertising = false
  saveSettings()
}

async function saveSettings() {
  const expiryDate = new Date()
  expiryDate.setMonth(expiryDate.getMonth() + 6)
  const consentCookie = useCookie('cc', {
    expires: expiryDate,
    path: '/',
  })
  consentCookie.value = JSON.stringify(consentOptions.value)
  isOpen.value = false

  // since useCookie create reactive reference we have to make sure to wait
  // for the mutation of the reactive state before calling enableTracking
  await nextTick()

  if (consentOptions.value.analytics) {
    const { $enableTracking } = useNuxtApp()
    $enableTracking()
  }

  if (consentOptions.value.advertising) {
    const gtm = useGtm()
    if (gtm) gtm.enable()
  }
}
</script>
